import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumDeleteCancelPopup1({
  onNext,
  onClose,
} : {
  onClose: () => void,
  onNext: () => void,
}) {
  return (
    <PopupContainer title="リリースの削除" onClose={() => { onClose(); }}>
      <form>
        <div className="list__body">
          <p>曲の権利を失ったなど、やむを得ず配信停止にする場合はこちらからお手続きください。</p>
          <p>・取下げ完了まで１ヶ月程度かかります</p>
          <p>・同じ内容のリリースを、今後当サービスから配信できない場合があります</p>
          <p>
            他のアーティストに関連付けられている、ストアの情報が間違っているなどのお問合せは
            <a href="https://help.frekul.com/">ヘルプ</a>
            からお知らせください。
          </p>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => { onClose(); }}>キャンセル</CustomButton>
              <CustomButton type="default-split" onClick={() => { onNext(); }}>配信停止へ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
